import React from 'react'
import Navigation from './Navigation'
import ToastList from '../ToastList'
import '../globalOverrides.css'

const RouteWithLayout = (props) => {
  return (
    <React.Fragment>
      <Navigation />
      <div id="main">
        <div>{props.children}</div>
        <div>
          <ToastList toasts={props.toasts} />
        </div>
      </div>
    </React.Fragment>
  )
}

export default RouteWithLayout
